import { array, object, ref, string } from "yup";

const registerSchema = object().shape({
  fullName: string()
    .min(3, "نام و نام‌خانوداگی حداقل سه کاراکتر")
    .required("نام و نام‌خانوادگی ضروری است"),
  phone: string()
    .typeError("شماره همراه نامعتبر است")
    .min(11, "شماره همراه نامعتبر است")
    .max(11, "شماره همراه نامعتبر است")
    .required("شماره همراه ضروری است"),
  password: string()
    .min(8, "رمزعبور حداقل ۸ کاراکتر")
    .matches(
      /^[a-zA-Z0-9-]+$/,
      "رمز عبور فقط می‌تواند شامل حروف انگلیسی، اعداد زیرخط باشد"
    )
    .required("رمزعبور ضروری است"),
  state: object().required("استان ضروری است").typeError("ضروری"),
  city: object().typeError("شهر ضروری است").required("شهر ضروری است"),
});

const loginSchema = object().shape({
  phone: string()
    .typeError("شماره همراه نامعتبر است")
    .min(11, "شماره همراه نامعتبر است")
    .max(11, "شماره همراه نامعتبر است")
    .required("شماره همراه ضروری است"),
  password: string()
    .min(8, "رمزعبور حداقل ۸ کارکتر")
    .required("رمزعبور ضروری است"),
});

const addOrderSchema = object().shape({
  fullName: string()
    .min(3, "نام و نام‌خانوداگی حداقل سه کاراکتر")
    .required("نام و نام‌خانوادگی ضروری است"),
  phone: string()
    .typeError("شماره همراه نامعتبر است")
    .min(10, "شماره همراه نامعتبر است")
    .max(10, "شماره همراه نامعتبر است")
    .required("شماره همراه ضروری است"),
  type: object().required("نوع درخواست ضروری است"),
  costAmount: object().required("انتخاب محدوده هزینه ضروری است"),
  state: object().required("استان ضروری است").typeError("ضروری"),
  city: object().typeError("شهر ضروری است").required("شهر ضروری است"),
  image: string().notRequired(),
  description: string(),
});

const addOrderInDashboardSchema = object().shape({
  type: object().required("نوع درخواست ضروری است"),
  costAmount: object().required("انتخاب محدوده هزینه ضروری است"),
  images: array().of(string()).notRequired(), // آرایه‌ای از استرینگ
  description: string(),
});

const verifyPhoneCodeSchema = object().shape({
  code: string().required("ضروری"),
});

const addCommentValidationSchema = object().shape({
  body: string()
    .min(3, "متن کامنت  حداقل سه کاراکتر")
    .required("متن کامنت ضروری است"),
});

const addCategorySchema = object().shape({
  label: string()
    .min(3, "عنوان دسته بندی حداقل ۳ کاراکتر")
    .required("عنوان دسته بندی ضروری است"),
  href: string()
    .min(2, "آدرس دسته بندی حداقل دو کاراکتر")
    .required("آدرس دسته بندی ضروری است"),
  description: string()
    .min(10, "توضیحات دسته بندی حداقل 10 کاراکتر")
    .required("توضیحات دسته بندی ضروری است"),
  image: string(),
});

const addBlogSchemaFront = object().shape({
  image: string()
    .matches(
      /\.(png|jpg|webp|jpeg)$/i,
      "فرمت تصویر باید jpg،jpeg، png یا webp باشد"
    )
    .required("تصویر اصلی مقاله ضروری است"),
  title: string()
    .min(35, "عنوان مقاله حداقل ۳۵ کاراکتر")
    .max(90, "عنوان مقاله حداکثر ۹۰ کاراکتر")
    .required("عنوان مقاله ضروری است"),
  category: object().required("دسته بندی مقاله ضروری است"),
  href: string()
    .min(3, "آدرس مقاله حداقل ۳ کاراکتر")
    .required("آدرس مقاله ضروری است"),
  metaDescription: string()
    .min(100, "توضیحات متا حداقل 100 کاراکتر")
    .max(200, "توضیحات متا حداکثر 200 کاراکتر")
    .required("توضیحات متا دسکریپشن ضروری است"),
  main: string()
    .min(10, "محتوای اصلی حداقل ۱۰ کاراکتر")
    .required("محتوای اصلی مقاله ضروری است"),
});

const forgotPasswordSchema = object().shape({
  phone: string()
    .typeError("شماره همراه نامعتبر است")
    .min(11, "شماره همراه نامعتبر است")
    .max(11, "شماره همراه نامعتبر است")
    .required("شماره همراه ضروری است"),
});

const changePasswordSchema = object().shape({
  password: string()
    .min(8, "رمز عبور باید حداقل ۸ کاراکتر باشد")
    .matches(/[a-zA-Z]/, "رمز عبور باید حاوی حروف باشد")
    .matches(/[0-9]/, "رمز عبور باید حاوی اعداد باشد")
    .required("رمز عبور الزامی است"),

  confirmPassword: string()
    .oneOf([ref("password")], "رمز عبور و تایید رمز عبور باید مشابه باشند")
    .required("تایید رمز عبور الزامی است"),

  verificationCode: string()
    .length(6, "کد تایید باید 6 رقم باشد") // فرض بر این است که کد تایید ۶ رقمی است
    .matches(/^[0-9]+$/, "کد تایید باید فقط شامل اعداد باشد")
    .required("کد تایید الزامی است"),
});

const addContactSchema = object().shape({
  fullName: string().required("نام و نام‌خانوادگی ضروری است"),
  phone: string()
    .matches(/^0\d{10}$/, "شماره همراه نامعتبر")
    .required("شماره موبایل الزامی است."),
  message: string()
    .min(10, "حداقل ۱۰ کاراکتر")
    .max(10000, "حداکثر ۱۰ هزار کاراکتر")
    .required("ضروری"),
  subject: object().required("ضروری"),
});

export {
  addContactSchema,
  addOrderInDashboardSchema,
  changePasswordSchema,
  forgotPasswordSchema,
  addBlogSchemaFront,
  registerSchema,
  loginSchema,
  addOrderSchema,
  verifyPhoneCodeSchema,
  addCategorySchema,
  addCommentValidationSchema,
};
